import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { WebAppBridge } from "./lib/WebAppBridge";
(window as any)["webapp"] = WebAppBridge;
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 100000,
            retry: 1,
            onError: (err: any) => {
                console.log("err>>>>>>>>>>>>>>>.", err);
            },
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <QueryClientProvider client={queryClient}>
        <App />
    </QueryClientProvider>,
);
